import React from "react";
import { Redirect } from "react-router-dom";

import useAuth from "../../hooks/useAuth";

const AuthGuard = ({ children }) => {
  const { isLoggedIn, isOTPValidated } = useAuth();
  if (!isLoggedIn) return <Redirect to="/auth/login" />;
  else if (isLoggedIn && !isOTPValidated)
    return <Redirect to="/auth/validate-otp" />;

  return <React.Fragment>{children}</React.Fragment>;
};

export default AuthGuard;
